export const _ = window._;
export const $ = window.jQuery;
export const ko = window.ko;
